
import React, { useState } from "react";
import ProgressTracker from "./ProgressTracker";
import CourseSidebar from "./CourseSidebar";

const TabComponent = () => {
    const [activeTab, setActiveTab] = useState("attendance");

    const tabs = [
      { id: "attendance", label: "ATTENDANCE" },
      { id: "assignment", label: "ASSIGNMENT" },
      { id: "assessment", label: "ASSESSMENT" },
    ];
  
  return (
   <div>
     <div className="container d-flex justify-content-center mt-2">
    <div className="w-75 max-w-3xl p-3 text-dark">
      <div className="nav nav-pills nav-justified shadow-sm rounded-pill p-1 shadow-sm border border-warning">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`nav-link text-uppercase fw-medium rounded-pill px-4 py-2 ${
              activeTab === tab.id ? "active text-white" : "text-dark"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  </div>
    <ProgressTracker/>
    <CourseSidebar/>
   </div>

  )
}

export default TabComponent